module.exports = __webpack_public_path__ + "static/media/Slice21@2x.e7133d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice21@2x.png
// module id = 1449
// module chunks = 0